module.exports = __webpack_public_path__ + "static/media/emrill.cac9ae74.svg";